import api from '@lib/api'
import { GetFileType, ResourceType } from '@orbit/api-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invalidateFileResource } from './fileResource'

interface UploadFilesVars {
	tripId: string
	files: File[]
	resourceType?: ResourceType
	resourceId?: number
}

export function useUploadFiles() {
	const queryClient = useQueryClient()

	return useMutation<GetFileType[], Error, UploadFilesVars>({
		mutationFn: async ({ tripId, files, resourceType, resourceId }) => {
			const formData = new FormData()
			files.forEach(file => formData.append('files', file))

			const params = new URLSearchParams()
			if (resourceType) params.set('resourceType', resourceType)
			if (resourceId !== undefined) params.set('resourceId', String(resourceId))

			const query = params.toString() ? `?${params.toString()}` : ''
			const { data } = await api.post<GetFileType[]>(
				`/trips/${tripId}/files${query}`,
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 },
			)
			return data
		},
		onSuccess: (_data, { tripId, resourceType }) => invalidateFileResource(queryClient, tripId, resourceType),
	})
}
